export const HOURS_IN_DAY = 8;
export const FIELD_REPAIR_HOUR_LIMIT = 5;
export const HO_SERVICE_HOUR_LIMIT = 8;
export const INTERNAL_HOUR_LIMIT = 8;
export const OVERTIME_HOUR_LIMIT = 4;
export const SPECIAL_JOBS_HOUR_LIMIT = 8;
export const FIELD_REPAIR_BUMP_HOUR_DAILY_LIMIT = 24;
export const PIECEWORK_LIMIT = 1;
export const NON_BILLABLE_PAYOUT_LIMIT = 150.0;
